'use strict';

/**
 * End point connection modules
 *
 * @type {{
 * goXHR(*=, *=, *=): Promise<unknown>,
 * getAjaxCall(*=, *=): Promise<unknown>,
 * goFetch(*=, *=): Promise<unknown>
 * }}
 */
const Connect = {
	/**
	 *
	 * Fetch API module
	 *
	 * Used to Fetch API calls
	 *
	 * @param request
	 * @returns {Promise<unknown>}
	 */
	goFetch(request) {
		return new Promise( resolve => {
			resolve(
				fetch(request)
					.then(response => { // Fetch response
						if (!response.ok)  {    // Handles Fetch OK response
							throw response;
						}
						return response.json();
					})
					.catch(err => {   // TODO Refactor code block and send error information to kibana
						if(!err.length && err.status > 200) {  // Handles empty response
							// TODO: Make the user aware of this error instead of silently logging in the console
							err = err.status;
						} else {
							err = 204;  // Status 204 : no content
						}
						return err;
					})
			);
		});
	},

	/**
	 *
	 * XMLHttpRequest (XHR) objects
	 *
	 * Used XHR calls (ajax)
	 *
	 * @param apiLocation
	 * @param data
	 * @returns {Promise<unknown>}
	 */
	goXHR(apiLocation, data) {
		// Create AJAX
		let ajax = new XMLHttpRequest();

		// Handles post data
		let postData = (typeof data !== 'undefined') ? JSON.stringify(data) : null;

		// Handles method type action
		let methodType = data ? 'POST' : 'GET';

		// Scope variables
		let err;

		return new Promise((resolve, reject) => {
			ajax.onload = () => { // Successful ajax call
				if (ajax.readyState === 4 && ajax.status === 200 && ajax.responseText) { // Success response
					resolve(JSON.parse(ajax.responseText));
				} else { // Failed response
					// TODO Refactor code block and send error information to kibana
					if (!ajax.responseText && ajax.status > 200) {
						err = ajax.status;
					} else {
						err = 204;  // Status 204 : no content
					}
					reject(err);
				}
			};
			ajax.open(methodType, apiLocation, true);
			ajax.setRequestHeader('Content-Type', 'application/json');
			ajax.send(postData);
		});
	},

	/**
	 *
	 * Get data by AJAX
	 *
	 * Make GET request via Fetch, fallback: XHR
	 *
	 *
	 * @param ajaxRequest
	 * @returns {Promise<unknown>}
	 */
	getAjaxCall(ajaxRequest) {
		// Assign request for Fetch API
		let request = new Request(ajaxRequest, {
			method: 'GET',
			mode: 'same-origin',
			redirect: 'follow',
			headers: new Headers({
				'Content-Type': 'application/json',
				'ReadOnlySession': false
			})
		});

		// Scope variables
		let getAjax;

		// Make AJAX request
		getAjax = (window.fetch) ? this.goFetch(request) : this.goXHR(ajaxRequest);

		return new Promise((resolve, reject) => {
			getAjax.then(getData => {
				if (!isNaN(getData)) { // Handles status code response
					throw getData;
				}
				resolve(getData);
			}).catch(err => {   // Handles AJAX error
				reject(err);
			});
		});
	}
};


module.exports =  {
	Connect: Connect
};
